module.exports = __webpack_public_path__ + "media/onyx.a212fe13.mp3";